import { createSQLiteAdapter } from "./SQLiteAdapter";
import { createDexieAdapter } from "./DexieAdapter";

// CW Browser (Electron) → SQLite via IPC | Web browser → IndexedDB via Dexie
const isSqliteMode = !!window.electronAPI?.db;
const db = isSqliteMode
  ? createSQLiteAdapter()
  : createDexieAdapter();

// In SQLite mode, every query re-checks window.electronAPI.db at call time
// (SQLiteAdapter.getElectronDB) and silently substitutes an empty-result stub
// if it's momentarily falsy — the IPC bridge going transiently unreachable
// (e.g. after the app resumes from idle) is indistinguishable from a real
// empty result to any caller. Callers that would otherwise treat an empty
// query result as "confirmed gone" (till-session staleness checks) must check
// this first and skip acting on the empty result when it's false, rather than
// mistaking "couldn't ask" for "the answer is no." Always true in Dexie mode,
// where toArray() genuinely reflects the data (no IPC hop to go stale).
export const isDbBridgeAvailable = () => !isSqliteMode || !!window.electronAPI?.db;

export default db;
